import { useState } from 'react';
import { styles } from '../../../styles/required-docs.styles';
import { SelectedDoc } from './RequiredDocsSelector';

export function CustomDocForm({ 
  onAdd, 
  onCancel 
}: { 
  onAdd: (doc: SelectedDoc) => void; 
  onCancel: () => void 
}) {
  const [label, setLabel] = useState('');
  const [description, setDescription] = useState('');
  const [formats, setFormats] = useState('.pdf');
  const [isRequired, setIsRequired] = useState(false);

  function handleSubmit() {
    if (!label.trim()) return;

    const key =
      'custom_' +
      label
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '') +
      '_' +
      Date.now();

    onAdd({
      key,
      label: label.trim(),
      description: description.trim(),
      acceptedFormats: formats.trim() || '.pdf',
      isRequired,
      isCustom: true,
    });
  }

  return (
    <div style={styles.customForm}>
      <div style={styles.formGrid}>
        <div>
          <label style={styles.label}>
            Nom du document <span style={{ color: '#8E0B56' }}>*</span>
          </label>
          <input
            style={styles.input}
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="Ex: Attestation de formation"
          />
        </div>
        <div>
          <label style={styles.label}>Formats acceptes</label>
          <input style={styles.input} value={formats} onChange={(e) => setFormats(e.target.value)} placeholder=".pdf" />
        </div>
      </div>
      <div style={styles.formRow}>
        <label style={styles.label}>Description</label>
        <input
          style={styles.input}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description du document attendu"
        />
      </div>
      <label style={styles.checkboxRow}>
        <input type="checkbox" checked={isRequired} onChange={(e) => setIsRequired(e.target.checked)} />
        Document obligatoire
      </label>
      <div style={styles.formActions}>
        <button type="button" style={styles.btnCancel} onClick={onCancel}>
          Annuler
        </button>
        <button
          type="button"
          style={{
            ...styles.btnPrimary,
            opacity: label.trim() ? 1 : 0.5,
            cursor: label.trim() ? 'pointer' : 'not-allowed',
          }}
          onClick={handleSubmit}
          disabled={!label.trim()}
        >
          Ajouter
        </button>
      </div>
    </div>
  );
}
